const distortCircles = (gsap) => {
  
  const $distortCircles = $('.distort-circle');
  
  if ($distortCircles.length) {
        
    $distortCircles.each(function() {
      const $this = $(this);
      const $filter = $this[0].querySelector('feDisplacementMap');
      
      const tl = gsap.timeline({paused: true});
      
      tl.to($filter, {
        duration: 0.2,
        ease: 'Expo.easeInOut', 
        attr: {
          scale: 60
        }
      })
      .to($filter, {
        duration: 0.6, 
        ease: 'Power3.easeOut',
        attr: {
          scale: 0
        }
      });
      
      
      $this.on('mouseenter', function() {
        tl.restart();
      });
      
      $this.on('mouseleave', function() {
        tl.progress(1).kill();
      });
      
    });
        
  }
  
}

export {
  distortCircles
};
